import { connect } from 'react-redux';
import { getSiteFeaturesList } from 'src/store/selectors/site.selectors';
import { getJournalEntriesBegin } from '../../store/actions/accounting.actions';
import { getJournalEntries, getJournalEntriesLoading } from '../../store/selectors/accounting.selectors';
import ReceivePaymentDialog from './ReceivePaymentDialog';

const mapStateToProps = (state: any) => ({
    journalEntries: getJournalEntries(state),
    journalEntriesLoading: getJournalEntriesLoading(state),
    featureFlags: getSiteFeaturesList(state),
});

const mapDispatchToProps = {
    getJournalEntries: getJournalEntriesBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceivePaymentDialog);
